export function sanitizeHtml(content: unknown): string {
  if (typeof content !== 'string' || content.length === 0) {
    return '';
  }

  const temp = document.createElement('div');
  temp.textContent = content;
  return temp.innerHTML;
}
